export const roundResult = (score) => Math.round(score * 10000) / 100;
